/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'hamburger': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="#212121" fill-rule="evenodd"><rect pid="0" x="3" y="5" width="14" height="2" rx="1"/><rect pid="1" x="3" y="9" width="14" height="2" rx="1"/><rect pid="2" x="3" y="13" width="14" height="2" rx="1"/></g>'
  }
})
